export const ALLOWED_EXTENSIONS = [
	'.doc',
	'.docx',
	'.xls',
	'.xlsx',
	'.pdf',
	'.jpeg',
	'.jpg',
	'.png',
];
